import { render } from "./welcome.vue?vue&type=template&id=4069533d&scoped=true"
const script = {}

import "./welcome.vue?vue&type=style&index=0&id=4069533d&scoped=scoped&lang=css"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4069533d"]])

export default __exports__